import React, { useState } from 'react';
import type { BasePortalSectionProps, PortalSection } from '../../types/portal-base';
import PortalSidebar from './PortalSidebar';

export const BasePortalSection: React.FC<BasePortalSectionProps> = ({
  config,
  onSubmit,
  onResetPasswordSubmit,
  onDownloadGuide,
  className = ''
}) => {
  const [activeSection, setActiveSection] = useState<PortalSection>('login');

  const handleSectionSwitch = (section: PortalSection) => {
    setActiveSection(section);
  };

  const handleBackToLogin = () => {
    setActiveSection('login');
  };

  const handleLoginSubmit = (formData: { username: string; password: string }) => {
    onSubmit(formData);
  };

  const handleResetPasswordSubmit = (email: string) => {
    onResetPasswordSubmit(email);
  };

  const handleDownloadGuide = () => {
    onDownloadGuide();
  };

  const renderActiveSection = () => {
    const sectionConfig = config.sections.find(s => s.id === activeSection);
    if (!sectionConfig) {
      return null;
    }

    const Component = sectionConfig.component;
    const props = {
      ...sectionConfig.props,
      onSubmit: activeSection === 'login' ? handleLoginSubmit : undefined,
      onResetPasswordSubmit: activeSection === 'reset-password' ? handleResetPasswordSubmit : undefined,
      onDownloadGuide: activeSection === 'download-guide' ? handleDownloadGuide : undefined,
      onBackToLogin: activeSection !== 'login' ? handleBackToLogin : undefined,
    };

    return <Component {...props} />;
  };

  const containerClass = config.theme === 'admin' 
    ? 'integrated-admin-section' 
    : 'integrated-portal-section';

  const contentAreaClass = config.theme === 'admin'
    ? 'admin-content-area'
    : 'integrated-content-area';

  return (
    <div className={`${containerClass} ${className}`}>
      <PortalSidebar
        theme={config.theme}
        activeSection={activeSection}
        onSectionChange={handleSectionSwitch}
        buttons={config.sidebarButtons}
      />
      
      <div className={contentAreaClass}>
        {renderActiveSection()}
      </div>
    </div>
  );
};

export default BasePortalSection;